export enum ActionType {
    CREATE,
    UPDATE,
    DELETE,
}
